import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {fetchAllTeasers} from '../../app/thunk'

export const teaserSlice = createSlice({
    name: 'teasers',
    initialState: {
        allTeasers: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchAllTeasers.fulfilled,
            (state: RootState, action) => {
                state.allTeasers = action.payload
            }
        )
    },
})

export default teaserSlice.reducer
